<div class="card" id="take-payment">
    <div class="card-body">
        <h2 class="card-title">Take Payment</h2>
    </div>

    <div class="card-body">
        <form [formGroup]="form">
            <div class="form-group row">
                <label class="col-xs-12 col-md-4 col-form-label" for="amount">Paid</label>
                <div class="col">
                    <input type="date" [id]="'paid-when'" class="form-control" formControlName="paid" />
                </div>
            </div>
            <div class="form-group row">
                <label class="col-xs-12 col-md-4 col-form-label" for="amount">Amount to Pay</label>
                <div class="col">
                    <currency-input [id]="'amount-to-pay'" [control]="form.get('amount')" (committed)="selectPays($event)" (blurred)="selectPays($event)"></currency-input>
                </div>
            </div>
            <ul class="list-group list-group-flush take-pay-list" formArrayName="payments">
                @for (paymentForm of payments.controls; track paymentForm; let i = $index) {
                <li class="list-group-item">
                    <form [formGroup]="paymentForm">
                        @if (!paymentForm.get('selected').value) {
                            <p class="check text-light" (click)="toggleSelectedPay(i)"><span class="material-icons">check_box_outline_blank</span></p>
                        }
                        @if (paymentForm.get('selected').value) {
                            <p class="check text-dark" (click)="toggleSelectedPay(i)"><span class="material-icons">check_box</span></p>
                        }
                        <div class="text-truncate clickable" (click)="toggleSelectedPay(i)">
                            <p class="title">{{paymentForm.get('label').value}}</p>
                        </div>
                        <p class="title text-right">{{paymentForm.get('amount').value}}</p>
                    </form>
                    @for (lineForm of lineControls(i); track lineForm; let j = $index) {
                        <div class="pay-line-list">
                            <div class="embedded-form" [formGroup]="lineForm">
                                @if (!lineForm.get('selected').value) {
                                    <p class="check text-light" (click)="toggleSelectedLine(i, j)"><span class="material-icons">check_box_outline_blank</span></p>
                                }
                                @if (lineForm.get('selected').value) {
                                    <p class="check text-dark" (click)="toggleSelectedLine(i, j)"><span class="material-icons">check_box</span></p>
                                }
                                <div class="text-truncate clickable" (click)="toggleSelectedLine(i, j)">
                                    <p class="subtitle">
                                        @if (lineForm.get('lienholder').value && (lineForm.get('lienholder').value.length > 0)) {
                                            {{lineForm.get('lienholder').value | titlecase}} check
                                        }
                                        @else {
                                            {{lineForm.get('category').value | lowercase}} due
                                        }
                                        <span class="due {{dueToClass(lineForm.get('due').value)}}">
                                            {{lineForm.get('due').value | date:'MMM d, yy'}}
                                        </span>
                                    </p>
                                </div>
                                <div class="form-group">
                                    <currency-input [id]="'pay-line-amount-' + paymentForm.get('id').value + '-' + j"
                                        [control]="lineForm.get('amount')" [suffix]="lineForm.get('full').value"
                                        (committed)="lineItemChanged($event, i, j)"
                                        (blurred)="lineItemChanged($event, i, j)"></currency-input>
                                </div>
                            </div>
                        </div>
                    }
                    <div class="button-bar">
                        @if (paymentForm.get('fees').value) {
                            <div class="alert alert-secondary" data-toggle="modal" title="Fees" 
                                data-target="#paymentFeesModal" (click)="selectTerm(paymentForm.get('termsId').value)">manage fees</div>
                        }
                    </div>
                </li>
                }
            </ul>
        </form>
    </div>

    <div class="card-body">
        <datalist id="zip-codes">
            @for (address of zipCodeList; track address) {
            <option (click)="zipSelected(address)" [value]="address.zipcode">
                {{address.zipcode}}, {{address.city}}</option>
            }
        </datalist>

        <ul class="nav nav-tabs">
            @if (accounts && (accounts.length > 0)) {
            <li class="nav-item">
                <a class="nav-link" [class.active]="accounts && (accounts.length > 0)" id="saved-acct-tab"
                    data-toggle="tab" data-target="#saved-account" role="tab">Saved</a>
            </li>
            }
            <li class="nav-item">
                <a class="nav-link" [class.active]="!accounts || (accounts.length <= 0)" id="new-acct-tab"
                    data-toggle="tab" data-target="#new-account" role="tab">Payment Method</a>
            </li>
        </ul>

        <div class="tab-content">
            @if (accounts && (accounts.length > 0)) {
            <div class="tab-pane fade" [class.active]="accounts && (accounts.length > 0)"
                [class.show]="accounts && (accounts.length > 0)" role="tabpanel" aria-labelledby="saved-account-tab"
                id="saved-account">
                <div class="card">
                    <div class="card-body">
                        <form [formGroup]="form" (submit)="take($event)">
                            <ul class="list-group list-group-flush pay-account-list">
                                @for (account of accounts; track account) {
                                <li class="list-group-item">
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" [value]="account.id"
                                            [id]="'pay-acct-choice-' + account.id" formControlName="accountId">
                                        <label class="form-check-label"
                                            [for]="'pay-acct-choice-' + account.id"><strong>{{account.label}}</strong>
                                            ending {{account.lastFour}}</label>
                                    </div>
                                </li>
                                }
                                <li class="list-group-item">
                                    <div class="form-row">
                                        <div class="col">
                                            <select class="form-control form-control-sm" formControlName="source">
                                                @for (source of sources[storedAcctMethodType.toLowerCase()]; track source) {
                                                <option [value]="source.toLowerCase()">{{source}}</option>
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </li>
                                <li class="list-group-item button-bar">
                                    <button type="submit" class="btn btn-success" (click)="take($event, true)" 
                                        [disabled]="form.invalid">pay</button>
                                </li>
                            </ul>
                        </form>
                    </div>
                </div>
            </div>
            }
            <div class="tab-pane fade" [class.active]="!accounts || (accounts.length <= 0)" [class.show]="!accounts || (accounts.length <= 0)" role="tabpanel" aria-labelledby="new-account-tab" id="new-account">
                <div class="card">
                    <div class="card-body">
                        <form [formGroup]="account" (submit)="take($event)">
                            <div class="form-row">
                                <div class="col">
                                    <select class="form-control form-control-sm" formControlName="type">
                                        @for (method of methods; track method) {
                                        <option [value]="method.toLowerCase()">{{method}}</option>
                                        }
                                    </select>
                                </div>
                                <div class="col">
                                    <select class="form-control form-control-sm" formControlName="source">
                                        @for (source of sources[payMethodType.toLowerCase()]; track source) {
                                        <option [value]="source.toLowerCase()">{{source}}</option>
                                        }
                                    </select>
                                </div>
                            </div>
                            @if (cash) {
                            <div class="form-row">
                                <div class="col col-form-label">
                                    <label for="paid-in-100s">Amount Paid in 100s</label>
                                </div>
                                <div class="col">
                                    <currency-input id="paid-in-100s"
                                        [control]="account.get('paidIn100s')"></currency-input>
                                </div>
                            </div>
                            }
                            @if ((card || bank) && (payMethodType !== 'pre-paid debit card')) {
                            <div class="form-row">
                                <div class="col">
                                    <input class="form-control form-control-sm" formControlName="holder"
                                        [placeholder]="bank ? 'Account holder name' : 'Card holder name'" />
                                </div>
                            </div>
                            }
                            @if (bank) {
                            <div class="form-row">
                                <div class="col">
                                    <input class="form-control form-control-sm" formControlName="route"
                                        placeholder="Bank ABA (routing) number" />
                                </div>
                            </div>
                            }
                            @if (card || bank) {
                            <div class="form-row">
                                <div class="col">
                                    <input class="form-control form-control-sm" formControlName="number"
                                        [placeholder]="bank ? 'Bank account number' : 'Card number'" />
                                </div>
                            </div>
                            }
                            @if (card) {
                            <div class="form-row">
                                <div class="col">
                                    <select class="form-control form-control-sm" formControlName="expiry_month">
                                        <option value="1">January (01)</option>
                                        <option value="2">February (02)</option>
                                        <option value="3">March (03)</option>
                                        <option value="4">April (04)</option>
                                        <option value="5">May (05)</option>
                                        <option value="6">June (06)</option>
                                        <option value="7">July (07)</option>
                                        <option value="8">August (08)</option>
                                        <option value="9">September (09)</option>
                                        <option value="10">October (10)</option>
                                        <option value="11">November (11)</option>
                                        <option value="12">December (12)</option>
                                    </select>
                                </div>
                                <div class="col">
                                    <select class="form-control form-control-sm" formControlName="expiry_year">
                                        @for (year of years; track year) {
                                        <option [value]="year">{{year}}</option>
                                        }
                                    </select>
                                </div>
                                <div class="col">
                                    <input class="form-control form-control-sm" formControlName="code"
                                        placeholder="Card security code" />
                                </div>
                            </div>
                            }
                            @if (check) {
                            <div class="form-row">
                                <div class="col">
                                    <input class="form-control form-control-sm" formControlName="checkNumber"
                                        placeholder="Check Number" />
                                </div>
                            </div>
                            }
                            @if (thirdParty) {
                            <div class="form-row">
                                <div class="col">
                                    <input class="form-control form-control-sm" formControlName="confirmation"
                                        placeholder="Confirmation Number" />
                                </div>
                            </div>
                            }
                            @if ((card || bank) && (payMethodType !== 'pre-paid debit card')) {
                            <div class="form-row">
                                <div class="col">
                                    <input class="form-control form-control-sm" formControlName="address"
                                        placeholder="Street Address" />
                                </div>
                                <div class="col">
                                    <div class="input-group input-group-sm">
                                        <input class="form-control form-control-sm" list="zip-codes"
                                            formControlName="zipCode" placeholder="Zip Code" />
                                        <div class="input-group-append"><span class="input-group-text"><span
                                                    class="dripicons-search"></span></span></div>
                                    </div>
                                    <small class="form-text text-muted">
                                        <span>{{account.get('city').value || ''}}</span>
                                        @if (account.get('city') && account.get('city').value &&
                                        (account.get('city').value.length > 0)) {
                                        <span>,</span>
                                        }
                                        <span>{{account.get('state').value || ''}}</span>
                                    </small>
                                </div>
                            </div>
                            }
                            @if ((card || bank) && (payMethodType !== 'pre-paid debit card')) {
                            <div class="form-row">
                                <div class="col">
                                    <div class="form-check-inline">
                                        <input id="save-pay-method" type="checkbox" class="form-check-input"
                                            formControlName="save" />
                                        <label for="save-pay-method" class="form-check-label">Save this method for
                                            future payments</label>
                                    </div>
                                </div>
                            </div>
                            }
                            <div class="button-bar">
                                <button type="submit" class="btn btn-sm btn-success" (click)="take($event)"
                                    [disabled]="form.invalid || account.invalid || (amountToPay <= 0)">Pay</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="paymentFeesModal" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="paymentFeesModal">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Payment Fees</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span>&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <payment-fees [termsId]="selectedTermsId" [language]="language"
                    (feesChanged)="feesChanged($event)"></payment-fees>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-light btn-sm" data-dismiss="modal">close</button>
            </div>
        </div>
    </div>
</div>